(() => {
  'use strict';

  const state = window.ShadowsDealFinalPolish = window.ShadowsDealFinalPolish || {};
  if (state.booted) return;
  state.booted = true;

  const ZERO_REVIEW_RE = /^(?:no reviews?|0(?:\.0+)?\s*(?:reviews?|ratings?))$/i;

  function productRoots(root = document) {
    const roots = [];
    if (root && root.matches && root.matches('[data-sdp-product]')) roots.push(root);
    if (root && root.querySelectorAll) roots.push(...root.querySelectorAll('[data-sdp-product]'));
    return roots;
  }

  function repairProductAvailability(root = document) {
    productRoots(root).forEach((productRoot) => {
      const master = productRoot.querySelector('select[name="id"]');
      if (!master || !master.options || master.selectedIndex < 0) return;
      const selected = master.options[master.selectedIndex];
      if (!selected) return;

      const available = !selected.disabled;
      const sectionId = productRoot.getAttribute('data-section-id') || '';
      const stock = productRoot.querySelector('[data-sdp-stock]');
      const mainButton = productRoot.querySelector(sectionId ? `#AddToCart-${sectionId}` : '.product-form__cart-submit');
      const mainLabel = productRoot.querySelector(sectionId ? `#AddToCartText-${sectionId}` : '.product-form__cart-submit span');
      const stickyButton = productRoot.querySelector('[data-sdp-sticky-submit]');
      const expectedLabel = available ? 'Add to Deal Bag' : 'Sold out';

      if (stock) {
        stock.classList.toggle('is-sold-out', !available);
        const expectedStockText = available ? 'In stock' : 'Sold out';
        const currentStockText = (stock.textContent || '').replace(/\s+/g, ' ').trim();
        if (currentStockText !== expectedStockText) {
          stock.innerHTML = `<span class="sdp-stock__dot" aria-hidden="true"></span>${expectedStockText}`;
        }
      }
      if (mainButton && mainButton.disabled === available) mainButton.disabled = !available;
      if (mainLabel && (mainLabel.textContent || '').trim() !== expectedLabel) mainLabel.textContent = expectedLabel;
      if (stickyButton) {
        if (stickyButton.disabled === available) stickyButton.disabled = !available;
        if ((stickyButton.textContent || '').trim() !== expectedLabel) stickyButton.textContent = expectedLabel;
      }
      productRoot.dataset.sdServerAvailability = available ? 'available' : 'sold-out';
    });
  }

  function hideZeroReviews(root = document) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-number-of-reviews="0"]').forEach((el) => {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
    });
    root.querySelectorAll('.jdgm-prev-badge, .jdgm-preview-badge, .spr-badge, [class*="review-badge"]').forEach((el) => {
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (ZERO_REVIEW_RE.test(text) || /\bno reviews?\b/i.test(text)) {
        el.hidden = true;
        el.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function normalizeProductButtons(root = document) {
    productRoots(root).forEach((productRoot) => {
      productRoot.querySelectorAll('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"]').forEach((button) => {
        if (button.disabled) return;
        const label = button.tagName === 'INPUT' ? button.value : button.textContent;
        const normalized = (label || '').trim();
        if (/^Add to Deal Bag$/i.test(normalized)) return;
        if (!/add(?:\s+to)?\s+(?:cart|bag|deal bag)/i.test(normalized)) return;
        if (button.tagName === 'INPUT') button.value = 'Add to Deal Bag';
        else button.textContent = 'Add to Deal Bag';
      });
    });
  }

  function isShopifyImage(url) {
    return /cdn\.shopify\.com|\/cdn\/shop\//i.test(url) && !/\.gif(?:\?|$)|\.svg(?:\?|$)/i.test(url);
  }

  function urlAtWidth(raw, width) {
    try {
      const url = new URL(raw, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (_) {
      return raw;
    }
  }

  function restoreResponsiveImages(root = document) {
    if (!root || !root.querySelectorAll) return;
    const selectors = [
      '.product-main-image img',
      '.product-gallery img',
      '.product-page img',
      '.sd-mobile-gallery img',
      '.sd-swipe-gallery img',
      '[data-product-media] img',
      '[data-sd-mobile-gallery] img'
    ].join(',');
    root.querySelectorAll(selectors).forEach((img) => {
      const raw = img.getAttribute('src') || img.currentSrc || '';
      if (!raw || !isShopifyImage(raw)) return;
      const widths = [360, 540, 720, 900, 1080, 1440];
      const desiredSrcset = widths.map((width) => `${urlAtWidth(raw, width)} ${width}w`).join(', ');
      if (img.getAttribute('srcset') !== desiredSrcset) img.setAttribute('srcset', desiredSrcset);
      if (!img.getAttribute('sizes')) img.setAttribute('sizes', '(max-width: 749px) 92vw, (max-width: 1100px) 52vw, 620px');
    });
  }

  function ensureMobileSearch() {
    if (!window.matchMedia('(max-width: 1040px)').matches) return;
    const actions = document.querySelector('.header-actions');
    if (!actions || actions.querySelector('.sd-header-search-link')) return;
    const existing = Array.from(actions.querySelectorAll('a,button')).some((el) => {
      const href = el.getAttribute('href') || '';
      const label = el.getAttribute('aria-label') || '';
      return /\/search(?:\?|$)/.test(href) || /search/i.test(label);
    });
    if (existing) return;

    const link = document.createElement('a');
    link.className = 'sd-header-search-link';
    link.href = '/search';
    link.setAttribute('aria-label', 'Search');
    link.innerHTML = '<i data-lucide="search" aria-hidden="true"></i>';
    actions.prepend(link);
    if (window.lucide && typeof window.lucide.createIcons === 'function') {
      try { window.lucide.createIcons(); } catch (_) {}
    }
  }

  function run(root = document) {
    repairProductAvailability(root);
    hideZeroReviews(root);
    normalizeProductButtons(root);
    restoreResponsiveImages(root);
    ensureMobileSearch();
    document.documentElement.classList.add('sd-final-polish-ready');
  }

  let scheduled = false;
  function scheduleRun() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      run(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run(document), { once: true });
  } else {
    run(document);
  }

  document.addEventListener('change', (event) => {
    const productRoot = event.target && event.target.closest && event.target.closest('[data-sdp-product]');
    if (productRoot) requestAnimationFrame(() => repairProductAvailability(productRoot));
  });

  window.addEventListener('resize', scheduleRun, { passive: true });
  document.addEventListener('shopify:section:load', (event) => run(event.target || document));

  // Bounded follow-up passes cover late app/theme hydration without watching the entire DOM.
  [150, 900, 2200].forEach((ms) => window.setTimeout(() => run(document), ms));
})();
